import { render, staticRenderFns } from "./VaccineIndex.vue?vue&type=template&id=f70326c4&"
import script from "./VaccineIndex.vue?vue&type=script&lang=js&"
export * from "./VaccineIndex.vue?vue&type=script&lang=js&"
import style0 from "./VaccineIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports